import { useState } from "react"

export const useGlobalStates = () => {
    
    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [componentModalDeposit, setComponentModalDeposit ] = useState('')

    //generales
    const [stepApplilication, setStepApplilication] = useState(0)

    // para formulario
    const [showForm, setShowForm ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')



    return Object.freeze({
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        componentModalDeposit, setComponentModalDeposit,
        stepApplilication, setStepApplilication,
        formOpeningMode, setFormOpeningMode,
        showForm, setShowForm,
    })
}